/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_No_Columns_FoundInputs */

const en_table_no_columns_found = /** @type {(inputs: Table_No_Columns_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No columns found.`)
};

const es_table_no_columns_found = /** @type {(inputs: Table_No_Columns_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron columnas.`)
};

/**
* | output |
* | --- |
* | "No columns found." |
*
* @param {Table_No_Columns_FoundInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const table_no_columns_found = /** @type {((inputs?: Table_No_Columns_FoundInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_No_Columns_FoundInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_no_columns_found(inputs)
	return es_table_no_columns_found(inputs)
});